import React, { useState, useEffect } from "react";
import axios from "axios";
import "./home.scss";
import countries from "./countries.js";
import { Link, useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  // This state controls the input value
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showError, setShowError] = useState(false);
  const [reasonToBuy, setReasonToBuy] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [error, setError] = useState(null);
  const [gender, setGender] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState("");
  const [ip, setIp] = useState("");
  const [age, setAge] = useState("");
  const [name, setName] = useState("");
  const [destination, setDestination] = useState("");
  const [receiveBrand, setReceiveBrand] = useState([]);
  const [shouldResubmit, setShouldResubmit] = useState(false);
  const [otherConsume, setOtherConsume] = useState({});
  const [considerbuying, setConsiderbuying] = useState("");
  const [productFeel, setProductFeel] = useState("");

  // Ratings (1–5)
  const [overallRating, setOverallRating] = useState({});
  const [tasteRating, setTasteRating] = useState({});
  const [textureRating, setTextureRating] = useState({});
  const [ingredientRating, setIngredientRating] = useState({});
  const [packagingRating, setPackagingRating] = useState({});
  const [findThisProductive, setFindThisProductive] = useState({});

  // NPS (1–10)
  const [recommendScore, setRecommendScore] = useState({});

  // Textareas
  const [likeMost, setLikeMost] = useState("");
  const [improvements, setImprovements] = useState("");
  const [likeLeast, setLikeLeast] = useState("");
  const [additionalComments, setAdditionalComments] = useState("");

  // Selects
  const [consume, setConsume] = useState({});

  const apiLink = "https://api-survey.notionsgroup.com/api/v1";

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    if (!isValidEmail(newEmail) && newEmail !== "") {
      setError("Invalid email format");
    } else {
      setError("");
    }
  };

  


  useEffect(() => {
    // Fetch user IP and approximate location
    axios
      .get("https://ipinfo.io/json?token=6bebd53a7455c1", {
        withCredentials: false,
      }) // Replace with your token from ipinfo.io
      .then((response) => {
        const userIp = response.data.ip;
        setIp(userIp);

        // Extract latitude and longitude
        const [lat, lng] = response.data.loc.split(",");
        setLocation({ lat: parseFloat(lat), lng: parseFloat(lng) });
      })
      .catch((error) => console.error("IP-based location error:", error));
  }, []);

  useEffect(() => {
    if (shouldResubmit && countries.includes(destination)) {
      setShouldResubmit(false);
      submitForm(new Event("submit")); // or manually call with dummy event
    }
  }, [destination, shouldResubmit]);

  const submitForm = async (e) => {
    e.preventDefault();
    setError("");

    // Basic form validation
    if (!name || !improvements || !likeMost || !email) {
      setError("Please fill all required fields.");
      return;
    }
    const data = {
      surveyName:"NPD-SHORT",
      name,
      location,
      email,
      likeMost,
      improvements,
      ip,
    };

    try {
      setLoading(true);
      const response = await axios.post(`/create-survey-npd-short`, data);
      navigate("/thank-you");
      setTimeout(() => setResponse(""), 3000);
    } catch (error) {
      setError("Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };;

  const handleChange = (e) => {
    const value = e.target.value;
    setDestination(value);
    setShowError(false);
    if (value) {
      const filtered = countries.filter((country) =>
        country.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredCountries(filtered);
      setShowDropdown(true);
    } else {
      setFilteredCountries([]);
      setShowDropdown(false);
    }
  };

  const handleSelect = (country) => {
    setDestination(country);
    setFilteredCountries([]);
    setShowDropdown(false);
  };

  const clearLocation = () => {
    localStorage.removeItem("userData");
    navigate("/location");
  };

  const value = "select";

  const handleCheckboxChange = (value) => {
    setReceiveBrand((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  const handleCheckboxChangePlace = (value) => {
    setFindThisProductive((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  const toggleCheckbox = (value, setState) => {
    setState((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  const sectionColors = [
    "#fef3c7", // light yellow
    "#dbeafe", // light blue
    "#dcfce7", // light green
    "#fee2e2", // light red/pink
    "#ede9fe", // light purple
  ];

  return (
    <div className="__fw">
      <div className="__mw">
        <form onSubmit={submitForm}>
          <div className="home">
            <div className="heading">
              <img src={require("../../img/logo.webp")} alt="" />
            </div>

            <div className="email_">
              <span>About You</span>
              <input
                type="text"
                value={name}
                placeholder="Full Name"
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* <div className="age">
              <select
                value={age}
                onChange={(e) => setAge(e.target.value)}
                className="select-dropdown"
              >
                <option value="" style={{ color: "grey" }}>
                  Select Age Group
                </option>
                <option value="Under 18">Under 18</option>
                <option value="18-24">18–24</option>
                <option value="25-34">25–34</option>
                <option value="35-44">35–44</option>
                <option value="45-54">45–54</option>
                <option value="55+">55+</option>
              </select>
            </div> */}

            {/* <div className="age">
              <select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="select-dropdown"
              >
                <option value="" style={{ color: "grey" }}>
                  Select Gender
                </option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div> */}

            {/* <div className="age">
              <div className="search_main_wrp">
                <div className="search_in">
                  <input
                    type="text"
                    value={destination} // This binds the input field with the state value
                    onChange={handleChange} // This updates the value dynamically
                    placeholder="Select Nationality"
                  />
                  {showDropdown && filteredCountries.length > 0 && (
                    <div className="country_list">
                      <ul>
                        {filteredCountries.slice(0, 5).map((country, index) => (
                          <li key={index} onClick={() => handleSelect(country)}>
                            {country}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {showError && (
                  <div className="error_msg">
                    <small className="msg_text">
                      Please enter a Nationality
                    </small>
                  </div>
                )}
              </div>
            </div> */}

            <div className="email_">
              <input
                type="text"
                value={email}
                placeholder="Your Email"
                onChange={handleEmailChange}
              />
            </div>
            <br />
            <div className="text_area">
              <span>
                How was your overall experience with the product, and what did
                you like most about it?
              </span>
              <textarea
                name=""
                rows={3}
                placeholder="Your feedback helps us improve."
                value={likeMost} // This binds the textarea value with the state
                onChange={(e) => setLikeMost(e.target.value)} // This dynamically updates the suggestion value
              ></textarea>
            </div>
            <br />
            <div className="text_area">
              <span>
                Are there any improvements or points you would like to share
                regarding the product?
              </span>
              <textarea
                name=""
                rows={3}
                placeholder="Your feedback helps us improve."
                value={improvements} // This binds the textarea value with the state
                onChange={(e) => setImprovements(e.target.value)} // This dynamically updates the suggestion value
              ></textarea>
            </div>

            {/* <div className="age">
              <span>Which Chocodate product did you receive?</span>

              <div className="checkbox-group">
                {[
                  "Rhutab Chocodate",
                  // "Chocodate Ice Cream",
                  "Chocodate Matcha",
                  "Chocodate Baklava",
                  "Chocodate Coconut Kunafa",
                  "Chocodate Biscoff",
                  "Chocodate Slabs",
                  "Chocodate Mini Slabs",
                ].map((item) => (
                  <label key={item} className="checkbox-item">
                    <input
                      type="checkbox"
                      checked={receiveBrand.includes(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                    <p className="checkbox-label">{item}</p>
                  </label>
                ))}
              </div>
            </div> */}

            {Array.isArray(receiveBrand) &&
              receiveBrand.map((item, index) => (
                <section
                  style={{
                    backgroundColor:
                      sectionColors[index % sectionColors.length],
                    padding: "10px",
                    borderRadius: "10px",
                    marginBottom: "15px",
                    marginTop: "1rem",
                    overflow: "hidden",
                    width: "100%",
                  }}
                  className="section"
                  key={index}
                >
                  <h4>{item}</h4>
                  <div className="age">
                    <span>How did you consume the product?</span>
                    <select
                      value={consume[item] || ""}
                      onChange={(e) =>
                        setConsume((prev) => ({
                          ...prev,
                          [item]: e.target.value,
                        }))
                      }
                      className="select-dropdown"
                    >
                      <option value="" style={{ color: "grey" }}>
                        Select One
                      </option>
                      <option value="As a snack">As a snack</option>
                      <option value="After a meal">After a meal</option>
                      <option value="With coffee / tea">
                        With coffee / tea
                      </option>
                      <option value="Shared with family or friends">
                        Shared with family or friends
                      </option>
                      <option value="Chocodate Coconut Kunafa">
                        Chocodate Coconut Kunafa
                      </option>
                      <option value="other">Other (please specify)</option>
                    </select>
                  </div>
                  <br />

                  {consume[item] === "other" ? (
                    <div className="text_area">
                      <textarea
                        type="text"
                        value={otherConsume[item] || ""} // This binds the email field with the state value
                        placeholder="Your feedback helps us improve."
                        onChange={(e) =>
                          setOtherConsume((prev) => ({
                            ...prev,
                            [item]: e.target.value,
                          }))
                        } // This updates email state
                      />
                    </div>
                  ) : null}

                  <div className="age">
                    <span>Overall, how would you rate the product?</span>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num, i) => (
                        <div
                          key={num}
                          onClick={() =>
                            setOverallRating((prev) => ({
                              ...prev,
                              [item]: num,
                            }))
                          }
                          className="hover_bk"
                          style={{
                            width: 40,
                            height: 40,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              overallRating[item] === num ? "#2563eb" : "#fff",
                            color:
                              overallRating[item] === num ? "#fff" : "#000",
                            borderRadius: 30,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Very poor</small>
                      <div className="line"></div>
                      <small className="green">Excellent</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>How would you rate the taste/flavor?</span>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num, i) => (
                        <div
                          key={num}
                          onClick={() =>
                            setTasteRating((prev) => ({ ...prev, [item]: num }))
                          }
                          className="hover_bk"
                          style={{
                            width: 40,
                            height: 40,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              tasteRating[item] === num ? "#2563eb" : "#fff",
                            color: tasteRating[item] === num ? "#fff" : "#000",
                            borderRadius: 30,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Very poor</small>
                      <div className="line"></div>
                      <small className="green">Excellent</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>
                      How would you rate the texture (bite, crunch, balance)?
                    </span>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num) => (
                        <div
                          key={num}
                          onClick={() =>
                            setTextureRating((prev) => ({
                              ...prev,
                              [item]: num,
                            }))
                          }
                          className="hover_bk"
                          style={{
                            width: 40,
                            height: 40,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              textureRating[item] === num ? "#2563eb" : "#fff",
                            color:
                              textureRating[item] === num ? "#fff" : "#000",
                            borderRadius: 30,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Very poor</small>
                      <div className="line"></div>
                      <small className="green">Excellent</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>How would you rate the quality of ingredients?</span>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num) => (
                        <div
                          key={num}
                          onClick={() =>
                            setIngredientRating((prev) => ({
                              ...prev,
                              [item]: num,
                            }))
                          }
                          className="hover_bk"
                          style={{
                            width: 40,
                            height: 40,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              ingredientRating[item] === num
                                ? "#2563eb"
                                : "#fff",
                            color:
                              ingredientRating[item] === num ? "#fff" : "#000",
                            borderRadius: 30,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Very poor</small>
                      <div className="line"></div>
                      <small className="green">Excellent</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>What did you like most about the product?</span>
                    <div className="text_area">
                      <textarea
                        name=""
                        rows={3}
                        placeholder="Your feedback helps us improve."
                        value={likeMost[item] || ""} // This binds the textarea value with the state
                        onChange={(e) =>
                          setLikeMost((prev) => ({
                            ...prev,
                            [item]: e.target.value,
                          }))
                        } // This dynamically updates the suggestion value
                      ></textarea>
                    </div>
                  </div>
                  <div className="age">
                    <span>
                      What did you like least or think could be improved?
                    </span>
                    <div className="text_area">
                      <textarea
                        name=""
                        rows={3}
                        placeholder="Your feedback helps us improve."
                        value={likeLeast[item] || ""} // This binds the textarea value with the state
                        onChange={(e) =>
                          setLikeLeast((prev) => ({
                            ...prev,
                            [item]: e.target.value,
                          }))
                        } // This dynamically updates the suggestion value
                      ></textarea>
                    </div>
                  </div>

                  <div className="age">
                    <span>How appealing did you find the packaging?</span>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num) => (
                        <div
                          key={num}
                          onClick={() =>
                            setPackagingRating((prev) => ({
                              ...prev,
                              [item]: num,
                            }))
                          }
                          className="hover_bk"
                          style={{
                            width: 40,
                            height: 40,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",

                            backgroundColor:
                              packagingRating[item] === num
                                ? "#2563eb"
                                : "#fff",
                            color:
                              packagingRating[item] === num ? "#fff" : "#000",
                            borderRadius: 30,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Very poor</small>
                      <div className="line"></div>
                      <small className="green">Excellent</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>Does the product feel premium to you?</span>
                    <select
                      value={productFeel[item] || ""}
                      onChange={(e) =>
                        setProductFeel((prev) => ({
                          ...prev,
                          [item]: e.target.value,
                        }))
                      }
                      className="select-dropdown"
                    >
                      <option value="" style={{ color: "grey" }}>
                        Select One
                      </option>
                      <option value="Yes, very premium">
                        Yes, very premium
                      </option>
                      <option value="Somewhat premium">Somewhat premium</option>
                      <option value="Neutral">Neutral</option>
                      <option value="Not premium">Not premium</option>
                    </select>
                  </div>
                  <div className="age">
                    <span>
                      Would you consider buying this product if you saw it in
                      store?
                    </span>
                    <select
                      value={considerbuying[item] || ""}
                      onChange={(e) =>
                        setConsiderbuying((prev) => ({
                          ...prev,
                          [item]: e.target.value,
                        }))
                      }
                      className="select-dropdown"
                    >
                      <option value="" style={{ color: "grey" }}>
                        Select One
                      </option>
                      <option value="Definitely yes">Definitely yes</option>
                      <option value="Probably yes">Probably yes</option>
                      <option value="Not sure">Not sure</option>
                      <option value="Probably not">Probably not</option>
                      <option value="Definitely not">Definitely not</option>
                    </select>
                  </div>

                  <div className="age">
                    <span>Where would you expect to find this product?</span>

                    <div className="checkbox-group">
                      {[
                        "Supermarket",
                        "Specialty chocolate shop",
                        "Gift store",
                        "Airport / Travel Retail",
                        "Online",
                      ].map((place) => (
                        <label key={place} className="checkbox-item">
                          <input
                            type="checkbox"
                            checked={
                              findThisProductive[item]?.includes(place) || false
                            }
                            onChange={() =>
                              setFindThisProductive((prev) => {
                                const current = prev[item] || [];

                                return {
                                  ...prev,
                                  [item]: current.includes(place)
                                    ? current.filter((p) => p !== place)
                                    : [...current, place],
                                };
                              })
                            }
                          />
                          <p className="checkbox-label">{place}</p>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="age">
                    <span>Would you recommend this product to others?</span>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                        <div
                          key={num}
                          onClick={() =>
                            setRecommendScore((prev) => ({
                              ...prev,
                              [item]: num,
                            }))
                          }
                          className="hover_bk"
                          style={{
                            width: 20,
                            height: 25,
                            border: "1px solid #ccc",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            backgroundColor:
                              recommendScore[item] === num ? "#2563eb" : "#fff",
                            color:
                              recommendScore[item] === num ? "#fff" : "#000",
                            borderRadius: 2,
                            //fontWeight: "bold",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        overflow: "hidden",
                        gap: "5px",
                        marginTop: 5,
                        alignItems: "center",
                      }}
                    >
                      <small className="red">Not at all </small>
                      <div className="line"></div>
                      <small className="green">Extremely likely</small>
                    </div>
                  </div>

                  <div className="age">
                    <span>Any additional comments or suggestions?</span>
                    <div className="text_area">
                      <textarea
                        name=""
                        rows={3}
                        placeholder="Your feedback helps us improve"
                        value={additionalComments[item] || ""} // This binds the textarea value with the state
                        onChange={(e) =>
                          setAdditionalComments((prev) => ({
                            ...prev,
                            [item]: e.target.value,
                          }))
                        } // This dynamically updates the suggestion value
                      ></textarea>
                    </div>
                  </div>
                </section>
              ))}

            <div className="submit_wrp">
              {!name || !email || !improvements || !likeMost ? null : (
                <button type="submit" className="button">
                  {loading ? <span>Please wait...</span> : <span>Submit</span>}
                </button>
              )}

              <div
                className="error_wrp"
                style={{
                  maxWidth: "300px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                {response && (
                  <small style={{ color: "#0db776" }}>{response}</small>
                )}
                {error && <small style={{ color: "red" }}>{error}</small>}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Home;
